import { useEffect } from "react";
import { notification } from "antd";
import { openBrowserRefreshNotification } from "../globalFunctions/GlobalFunctions";
import { fetchApi } from "../services/api";
const useAutoReloadOnNewBuild = (interval = 60000) => {
	useEffect(() => {
		let stopped = false;
		let isChecking = false;
		const currentPath = window.location.pathname;
		const getBackendVersion = async () => {
			try {
				const res = await fetchApi("/version", "get");
				if (res && res.code === 200 && res.data) {
					return res.data;
				}
				return null;
			} catch (err) {
				console.log("Backend version fetch failed", err);
				return null;
			}
		};
		const checkVersion = async () => {
			if (isChecking || stopped) return;
			isChecking = true;
			try {
				const res = await fetch(`${currentPath}?t=${Date.now()}`, {
					cache: "no-store",
					credentials: "same-origin"
				});
				const html = await res.text();
				const metaMatch = html.match(
					/<meta\s+name=["']app-version["']\s+content=["']([^"']+)["']/
				);
				const beMatch = html.match(
					/<meta\s+name=["']backend-version["']\s+content=["']([^"']+)["']/
				);
				if ((!metaMatch && !beMatch) || stopped) return;
				const serverVersion = metaMatch?.[1];
				const serverBackendVersion = beMatch?.[1];
				const storedVersion = localStorage.getItem("app_version");
				const storedBackendVersion = localStorage.getItem("backend_version");
				if (!storedVersion && serverVersion) {
					localStorage.setItem("app_version", serverVersion);
				}
				if (!storedBackendVersion && serverBackendVersion) {
					localStorage.setItem("backend_version", serverBackendVersion);
				}
				const isFrontendChanged =
			serverVersion &&
			storedVersion &&
			serverVersion !== storedVersion;
				const isBackendChanged =
			serverBackendVersion &&
			storedBackendVersion &&
			serverBackendVersion !== storedBackendVersion;
				if (isFrontendChanged || isBackendChanged) {
					if (serverVersion) {
						localStorage.setItem("app_version", serverVersion);
					}
					if (serverBackendVersion) {
						localStorage.setItem("backend_version", serverBackendVersion);
					}
					notification.destroy();
					const data = await getBackendVersion();
					{data?.is_enabled === "t" && openBrowserRefreshNotification( data );}
				}
			} catch (err) {
				console.log("Version check failed:", err);
			} finally {
				isChecking = false;
			}
		};
		checkVersion();
		const timer = setInterval(checkVersion, interval);
		return () => {
			stopped = true;
			clearInterval(timer);
		};
	}, [interval]);
};
export default useAutoReloadOnNewBuild;